export enum DropDownType {
  insights = 'insights',
  timeFrames = 'timeFrames',
  support = 'support',
}
